import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b6e33e9a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b6e33e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e33e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6e33e9a')) {
      api.createRecord('b6e33e9a', component.options)
    } else {
      api.reload('b6e33e9a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b6e33e9a&scoped=true&", function () {
      api.rerender('b6e33e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2We82f2iGvkGZ/JS/comp/SearchFilterTokens.vue"
export default component.exports